import { Component, OnInit } from '@angular/core';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-officers',
    templateUrl: './officers.component.html',
    styleUrls: ['./officers.component.scss'],
    standalone: false
})
export class OfficersComponent implements OnInit {

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn('Id', 'Id'),
    new Datalistviewcolumn('Badge', 'BadgeNumber'),
    new Datalistviewcolumn('Officer', 'UserName'),
    new Datalistviewcolumn('Email', 'UserEmail'),
    new Datalistviewcolumn('Active', 'IsActive')
  ];

  constructor() { }

  async ngOnInit(): Promise<void> {
  }
}


